import { AsyncPipe, CommonModule, CurrencyPipe, DatePipe, JsonPipe } from '@angular/common';
import { AfterViewInit, Component, DestroyRef, inject, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule, MatDateRangeInput } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarModule, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  IGX_GRID_DIRECTIVES,
  IgxActionStripModule,
  IgxExcelExporterOptions,
  IgxExcelExporterService,
  IgxGridComponent,
  IgxGridModule,
  IgxSwitchModule,
  IgxTabsModule,
  IPinningConfig,
  RowPinningPosition,
} from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { IReportRecurringTasksResponse } from 'src/app/shared/interfaces';
import { HeaderTitleLotDataComponent } from 'src/app/shared/ui/header-title-lot-data/header-title-lot-data.component';
import { AgingCommentsUpdateComponent } from '../../dialog-report/aging-comments-update/aging-comments-update.component';
import { environment } from 'src/environments/environment';
import { IgxPreventDocumentScrollModule } from 'src/app/shared/directives/prevent-scroll.directive';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-report-recurring-task',
  standalone: true,
  imports: [
    MatSlideToggleModule,
    MatExpansionModule,
    MatIconModule,
    CommonModule,
    MatTabsModule,
    MatSnackBarModule,
    MatTableModule,
    MatCardModule,
    MatOptionModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    IgxGridModule,
    IgxTabsModule,
    IgxGridComponent,
    HeaderTitleLotDataComponent,
    MatTooltipModule,
    MatButtonModule,
    MatDialogModule,
    IgxActionStripModule,
    IgxSwitchModule,
    IgxPreventDocumentScrollModule,
    CurrencyPipe,
    MatCheckboxModule,
    FormsModule,
  ],
  templateUrl: './report-recurring-task.component.html',
  styleUrl: './report-recurring-task.component.scss',
})
export class ReportRecurringTaskComponent implements OnInit {
  reportTaskSummary: IReportRecurringTasksResponse[] = [];

  //Services
  private dataService = inject(DataService);
  public _appGeneralState = inject(AppGeneralStateService);
  private _destroyRefService = inject(DestroyRef);
  _messageService = inject(MessageDialogService);
  _snackBar = inject(MatSnackBar);
  _dialog = inject(MatDialog);
  _datePipe = inject(DatePipe);

  recurringTaskReportForm = new FormGroup({
    taskType: new FormControl('', [Validators.required]),
  });

  ngOnInit(): void {}

  onSubmitAutomatedTasksReport(): void {
    let taskName: string = 'ALL';

    taskName = this.recurringTaskReportForm.get('taskType').value;

    if (taskName == 'all') {
      taskName = 'ALL';
    } else if (taskName == 'spaceaccount') {
      taskName = 'SpaceEmail Account Integrity Check';
    } else if (taskName == 'monthlylpr') {
      taskName = 'Monthly LPR Vehicle Update';
    } else {
      taskName = 'ALL';
    }

    this.getRecurringTasksReport(taskName);
  }

  getRecurringTasksReport(taskName: string) {
    this.reportTaskSummary = [];

    this.dataService
      .getReportAutomatedTasksSummaryData(taskName)
      .pipe(takeUntilDestroyed(this._destroyRefService))
      .subscribe({
        next: (res) => {
          this.reportTaskSummary = res;
        },
        error: (err: any) => {
          this._snackBar.dismiss();
          this._messageService.snackBarTopCenterTimed(
            'An unexpected error occurred while loading the Recurring Task report.  Please try again.',
            5000,
          );
        },
        complete: () => {
          if (this.reportTaskSummary.length == 0) {
            this._messageService.snackBarTopCenterTimed('No tasks found for this Task Name.', 5000);
          }
        },
      });
  }
}
